import React from 'react';
import FormSection from '@shared/components/FormSection';
import StyledTextField from '@shared/components/StyledTextField';
import GenericDropdown from '@shared/components/GenericDropdown';
import { countries } from '@shared/helpers/constants';

const PassengerForm = ({ passenger, paxIndex, formik, search }) => {
  let title =
    passenger.passengerType === 1
      ? `Adulto${paxIndex === 0 ? ' (Titular)' : ''}`
      : passenger.passengerType === 2
      ? `Menor (${search?.passengers[paxIndex]?.age} años)`
      : 'Menor de 2 años';

  return (
    <FormSection
      title={title}
      customLayout={{ md: { 1: 4, 2: 4, 3: 2, 4: 2, 5: 4, 6: 4 } }}
    >
      <StyledTextField
        formik={formik}
        name={`passengers[${paxIndex}].nombre`}
        label="Nombre (según documento)"
        fullWidth
      />
      <StyledTextField
        formik={formik}
        name={`passengers[${paxIndex}].apellido`}
        label="Apellido (según documento)"
        fullWidth
      />
      <StyledTextField
        formik={formik}
        name={`passengers[${paxIndex}].numerodedocumento`}
        label="DNI - Pasaporte"
        fullWidth
      />
      <StyledTextField
        formik={formik}
        name={`passengers[${paxIndex}].fechadenacimiento`}
        type="date"
        label="Fecha de Nacimiento"
        fullWidth
      />
      <GenericDropdown
        formik={formik}
        name={`passengers[${paxIndex}].pais`}
        items={countries.map(c => ({
          id: c.id_country,
          fragments: [{ text: c.name }],
        }))}
        selectedItem={
          countries.find(c => c.id_country == passenger.pais)
            ? {
                id: passenger.pais,
                fragments: [
                  {
                    text: countries.find(c => c.id_country == passenger.pais)
                      .name,
                  },
                ],
              }
            : null
        }
        buttonLabel="País"
      />
      <GenericDropdown
        formik={formik}
        name={`passengers[${paxIndex}].nacionalidad`}
        items={countries.map(c => ({
          id: c.id_country,
          fragments: [{ text: c.name }],
        }))}
        selectedItem={
          countries.find(c => c.id_country == passenger.nacionalidad)
            ? {
                id: passenger.nacionalidad,
                fragments: [
                  {
                    text: countries.find(
                      c => c.id_country == passenger.nacionalidad
                    ).name,
                  },
                ],
              }
            : null
        }
        buttonLabel="Nacionalidad"
      />
    </FormSection>
  );
};

export default PassengerForm;
